import PropTypes from 'prop-types'
import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import cx from 'classnames'
import { isURL } from 'validator'
import { Input, Button } from '@drifthq/tide-core'
import { track } from 'utils/trackingUtils'
import { OnboardingHeader } from "components/OnboardingHeader"
import InstallNotification from "components/OnboardingInstallNotification"
import OnboardingWidgetTip, { TipTextType }  from 'components/OnboardingWidgetTip'
import BackButton from 'components/OnboardingBackButton'
import { DisabledButton } from 'components/OnboardingDisabledButton'
import { isEmpty } from 'ramda'
import { verifyWidgetSnippet } from 'modules/snippet/api'
import { setWidgetVerified } from 'modules/playbook/actions'

import './style.css'

const VERIFY_TOOLTIP = <div>Verify that Drift was installed<br/>successfully before proceeding</div>

const SUCCESS_MESSAGE = "Woohoo! Drift is successfully installed on your site."
const ERROR_MESSAGE = "We couldn't verify that Drift is installed at this URL. Make sure you're checking the correct URL, and try again!"

export const SkipInstallLink = ({ text, linkText, onClick }) => (
  <div className="skip-install-container">
    {text}
    <a onClick={onClick}>
      {linkText}
    </a>
  </div>
)

class Verify extends Component {

  static propTypes = {
    onContinue: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props)
    this.state = {
      verificationUrl: '',
      isValidVerificationUrl: false,
      verified: null,
    }
  }

  verifyWidget = () => {
    const { verificationUrl } = this.state

    const onSuccess = (response) => {
      const { actions } = this.props
      this.setState({ verified: response.ok })
      actions.setWidgetVerified(response.ok)
    }

    const onFailure = (err) => {
      console.warn(err)
      this.setState({ verified: false })
    }

    verifyWidgetSnippet(verificationUrl, false)
      .then(onSuccess)
      .catch(onFailure)
  }

  onVerifyUrlChanged = (event) => {
    const value = event.target ? event.target.value : ''

    this.setState({ verificationUrl: value, isValidVerificationUrl: isURL(value) })
  }

  onVerifySkipClicked = () => {
    const { name, segment } = this.props
    track(`${name} Step - Skipped`, { route: '/verify', segment: segment })
  }

  render() {
    const { verificationUrl, isValidVerificationUrl, verified } = this.state
    const { onContinue } = this.props

    return (
      <Fragment>
        <div className="verify-install-wrapper">
          <OnboardingHeader
            title="Verify your Drift installation"
            description="Let’s finish up by verifying that your code was installed successfully."
          />
          <div className="verify-install-body">
            <p className="verify-install-body--title">Enter the URL where you installed Drift and click to verify.</p>
            <div className="verify-install-input-row">
              <div className="verify-install-url-container">
                <Input
                  className={cx("verify-install-input", {"verify-install-invalid": !isValidVerificationUrl && !isEmpty(verificationUrl) })}
                  onChange={this.onVerifyUrlChanged}
                  value={verificationUrl}
                  placeholder="http://yourwebsite.com"
                />
                <Button
                  className="verify-install-button"
                  type="tertiary"
                  onClick={this.verifyWidget}
                  disabled={!isValidVerificationUrl}>
                  Verify
                </Button>
              </div>
              <InstallNotification
                className="verify-install-notification"
                errorText={ERROR_MESSAGE}
                isError={verified === false}
                isSuccess={!!verified}
                successText={SUCCESS_MESSAGE}
              />
            </div>
          </div>
          { !verified && <DisabledButton buttonText="Next" buttonClassName="verify-install-next-button" toolTipText={VERIFY_TOOLTIP}/> }
          <SkipInstallLink
            text="Not ready to verify just yet? "
            linkText="Skip this step"
            onClick={() => {
              onContinue()
              this.onVerifySkipClicked()
            }}
          />
          { verified &&
            <Button
              className="verify-install-next-button"
              onClick={onContinue}>
              Next
            </Button>
          }
          <BackButton/>
        </div>
        <OnboardingWidgetTip tipTextKey={TipTextType.STUCK} />
      </Fragment>
    )
  }
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    setWidgetVerified,
  }, dispatch),
})

export default connect(null, mapDispatchToProps)(Verify)


// WEBPACK FOOTER //
// ./src/layouts/OnboardingInstallStep/Verify/index.js